import { css } from '@/styled-system/css';

export const dateTimeBlockDayRecipe = css.raw({
  'minBlockSize': '2400',
  'minInlineSize': '99px',
  'paddingBlock': 'loose',
  'paddingInline': 'loose',

  '& > .c11n_toggle-card__body': {
    display: 'grid',
    justifyContent: 'center',
    justifyItems: 'center',
  },
});
